import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../components/Icon';
import { EmptyState, Page, PageHead, Petals, Reveal } from '../components/UI';
import { api } from '../utils/api';

export function Stories() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api('/public/stories').then((d) => setItems(d.items)).catch(() => {});
  }, []);
  return (
    <Page>
      <section className="banner">
        <Petals count={10} />
        <motion.h1 initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}>Happily ever <em>after</em></motion.h1>
        <p>Real couples from the medical community who met on CTshaadi.</p>
      </section>
      <div className="container stories-grid">
        {items.map((s, i) => (
          <Reveal key={s.id} delay={(i % 2) * 0.1} className={`story story--wide ${i % 2 ? 'story--flip' : ''}`}>
            <div className="story__img"><img src={s.image} alt={s.couple} loading="lazy" /></div>
            <div className="story__body">
              <Icon name="heart" size={22} fill="currentColor" stroke={0} className="story__heart" />
              <p>“{s.quote}”</p>
              <strong>{s.couple}</strong>
              <small className="muted">{s.meta}</small>
            </div>
          </Reveal>
        ))}
        <Reveal className="center">
          <Link to="/register" className="btn btn--primary btn--lg">Start your story <Icon name="heart" size={17} fill="currentColor" stroke={0} /></Link>
        </Reveal>
      </div>
    </Page>
  );
}

const FAQ = [
  ['Is CTshaadi only for doctors?', 'CTshaadi is designed for doctors and all healthcare professionals — nurses, dentists, pharmacists, physiotherapists, AYUSH practitioners and medical students. Anyone who values that world is welcome to join.'],
  ['How does “Continue with MedHire” work?', 'You sign in with your MedHire email and password. We read your MedHire profile (name, education, work history, location and more) to pre-fill CTshaadi. We never change anything on MedHire, and you can edit every field before your profile goes live.'],
  ['Will my MedHire salary be shown?', 'Only if you choose. During sign-up (and anytime in Edit profile → Career) you can show the same salary as MedHire, enter a different amount, or keep it private. You can also limit it to Premium members.'],
  ['Who can see my photos and contact number?', 'You decide in Privacy & settings. Photos can be visible to everyone or only Premium members. Contact details can be shown to Premium members, only to people whose interest you accepted, or to no one.'],
  ['How is the match percentage calculated?', 'We compare each profile with your partner preferences (age, height, religion, city, profession, diet and more), check whether you fit their preferences too, and add a small boost for things like the same city.'],
  ['Is the Kundli score accurate?', 'It follows the traditional 36-guna Ashtakoot method using rashi and nakshatra. Treat it as one input among many — and for important decisions, consult your family astrologer.'],
  ['How do I delete my profile?', 'Go to Privacy & settings → Delete profile. Your CTshaadi profile is removed; a linked MedHire account is not affected.'],
];

const SAFETY = [
  ['shield', 'Never share money', 'No genuine match will ask for money, gifts or bank details. Report anyone who does.'],
  ['users', 'Involve your family', 'Let family know who you are talking to and when you plan to meet.'],
  ['pin', 'Meet in public', 'Keep first meetings in busy public places like cafés, and arrange your own travel.'],
  ['flag', 'Report & block', 'Use the menu on any profile to block or report. Our safety team reviews every report within 24 hours.'],
];

export function Help() {
  const [open, setOpen] = useState(0);
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth' });
  }, [hash]);
  return (
    <Page>
      <div className="container narrow">
        <PageHead eyebrow="Help centre" title="How can we help?" sub="Answers to common questions, safety tips and policies." />
        <div className="faq">
          {FAQ.map(([q, a], i) => (
            <div key={q} className={`faq__item ${open === i ? 'is-open' : ''}`}>
              <button className="faq__q" onClick={() => setOpen(open === i ? -1 : i)}>
                {q}
                <motion.span animate={{ rotate: open === i ? 45 : 0 }}><Icon name="plus" size={18} /></motion.span>
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="faq__a">
                    <p>{a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>

        <h2 id="safety" className="section-title">Stay safe</h2>
        <div className="safety">
          {SAFETY.map(([icon, t, d], i) => (
            <Reveal key={t} delay={i * 0.06} className="safety__item">
              <span className="feature__icon tint-teal"><Icon name={icon} size={20} /></span>
              <div><strong>{t}</strong><p className="muted">{d}</p></div>
            </Reveal>
          ))}
        </div>

        <h2 id="privacy" className="section-title">Privacy policy</h2>
        <p className="muted">We collect the details you add to your profile and, if you choose “Continue with MedHire”, read your MedHire profile once (and again whenever you press “Sync”). We do not write to MedHire. Your data is never sold. Contact details are only revealed according to your privacy settings.</p>
        <h2 id="terms" className="section-title">Terms of use</h2>
        <p className="muted">CTshaadi is for people seeking marriage. You must be 18+ (21+ for men per Indian law to marry), share truthful information and treat other members with respect. Profiles that violate these terms may be removed.</p>

        <div className="contact-strip">
          <Icon name="phone" size={20} />
          <span>Still need help? Call <strong>+91 1800 120 4545</strong> or write to <strong>care@ctshaadi.com</strong></span>
        </div>
      </div>
    </Page>
  );
}

export function NotFound() {
  return (
    <Page>
      <div className="container">
        <EmptyState icon="heart" title="This page eloped 💍" text="We couldn't find what you were looking for." action={<Link to="/" className="btn btn--primary">Take me home</Link>} />
      </div>
    </Page>
  );
}
